/* Article page. One job: the copy-link button.
 *
 * Everything else in the share row is a plain link and needs no script.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-copy-link]').forEach(function (button) {
    button.addEventListener('click', function () {
      var url = button.getAttribute('data-url');
      var original = button.textContent;

      function done(message) {
        button.textContent = message;
        window.setTimeout(function () { button.textContent = original; }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () { done('Copied'); },
          function () { done('Press ⌘C'); }
        );
        return;
      }

      // No clipboard API (older Safari, any non-secure context): select the URL
      // so the keyboard shortcut still works rather than failing silently.
      var field = document.createElement('input');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try { document.execCommand('copy'); done('Copied'); } catch (e) { done('Press ⌘C'); }
      document.body.removeChild(field);
    });
  });
})();
